<template>
  <a-spin :tip="loadingTip" :spinning="isloading" class="cmswrapper">
    <div>
      <div>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item label="试卷名称" :label-col="{ span: 4 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入试卷名称"
              v-decorator="[
          'testpaperName',
          {rules: [{ required: true, message: '请输入试卷名称!' }],initialValue:info.testpaperName}
        ]"
            ></a-input>
          </a-form-item>

          <div class="questionList">
            <a-divider>试题</a-divider>
            <a-row :gutter="24">
              <a-col :span="8">
                <a-button-group>
                  <a-button type="primary" @click="questionChoose">手工添加</a-button>
                  <a-button type="primary" @click="ruleSet">随机抽题</a-button>
                </a-button-group>
              </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="10" :style="{margin: '18px', fontSize: '16px'}">分数设置: </a-col>
            </a-row>
            <a-row :gutter="24">
              <a-col :span="7">
                <a-form-item label="单选题" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
                  <a-input-number @change="setScore" placeholder="分值" v-model="singleScore" />
                  <span>/ {{singleTotalCount}}</span>
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item label="多选题" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
                  <a-input-number @change="setScore" placeholder="分值" v-model="multiScore"></a-input-number>
                  <span>/ {{multiTotalCount}}</span>
                </a-form-item>
              </a-col>
              <a-col :span="7">
                <a-form-item label="判断题" :label-col="{ span: 7 }" :wrapper-col="{ span: 15 }">
                  <a-input-number @change="setScore" placeholder="分值" v-model="judgeScore"></a-input-number>
                  <span>/ {{judgeTotalCount}}</span>
                </a-form-item>
              </a-col>
              <a-col :span="3">
                <a-form-item
                  label="总分"
                  :label-col="{ span: 9 }"
                  :wrapper-col="{ span: 15 }"
                >{{singleScore*singleTotalCount+multiScore*multiTotalCount+judgeScore*judgeTotalCount}}</a-form-item>
              </a-col>
            </a-row>

            <a-table
              :columns="list.columns"
              rowKey="id"
              :pagination="list.pagination"
              :dataSource="question"
              :loading="isloading"
              :locale="{emptyText:'暂无数据'}"
            >
              <span slot="subjectType" slot-scope="subjectType">
                <span v-if="subjectType.subjectType==0">单选题</span>
                <span v-else-if="subjectType.subjectType==1">多选题</span>
                <span v-else>判断题</span>
              </span>
              <span slot="action" slot-scope="info">
                <pxkeji-btn
                  name="删除"
                  :roles="[]"
                  size="small"
                  @click="removeInfo(info.subjectId)"
                  type="primary"
                />
              </span>
            </a-table>
          </div>
          <a-form-item :wrapper-col="{ span: 19, offset: 4 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" style="margin-left:10px;" />
          </a-form-item>
        </a-form>

        <a-modal
          title="抽题规则"
          v-model="RuleInfo.visible"
          width="50%"
          :footer="false"
          destroyOnClose
          :maskClosable="false"
        >
          <RuleInfo @callbackMethod="RuleInfoback" :selList="questionList.selList" />
        </a-modal>

        <a-modal
          title="选择题目"
          v-model="questionList.visible"
          width="80%"
          :footer="false"
          destroyOnClose
          :maskClosable="false"
        >
          <questionList
            @callbackMethod="getquestion"
            :selList="questionList.selList"
            :examinationId="examinationId"
          />
        </a-modal>
      </div>
    </div>
  </a-spin>
</template>

<script>
import RuleInfo from "./ruleInfo.vue"; //抽题规则
import questionList from "./questionList.vue"; //选题

var that;
var quesList = [];
var quesArr = [];

const columns = [
  {
    dataIndex: "subjectName",
    key: "subjectName",
    align: "center",
    title: "题目名称"
  },
  {
    title: "类型",
    key: "subjectType",
    align: "center",
    scopedSlots: { customRender: "subjectType" }
  },
  {
    title: "操作",
    key: "action",
    width: 200,
    align: "center",
    scopedSlots: { customRender: "action" }
  }
];

export default {
  props: {
    id: String,
    examinationId: String,
    limit: Number
  },
  data() {
    return {
      list: {
        columns, //表头
        datas: [], //数据
        pagination: {
          //分页器
          showQuickJumper: true,
          hideOnSinglePage: true,
          total: 0,
          current: 1, //页码
          defaultPageSize: 10 //页容
        }
      },
      singleScore: 0,
      multiScore: 0,
      judgeScore: 0,
      multiTotalCount: 0,
      singleTotalCount: 0,
      judgeTotalCount: 0,
      form: this.$form.createForm(this),
      info: {
        categoryId: [0],
        examId: 0,
        subjectIds: ""
      },
      treeData: [],
      joblist: [],
      isloading: false,
      loadingTip: "加载中...",
      ansArr: [{ type: 1 }, { type: 2 }, { type: 3 }, { type: 4 }],
      examList: {
        visible: false
      },
      RuleInfo: {
        visible: false
      },
      questionList: {
        visible: false,
        selList: []
      },
      quesList: [],
      question: [],
      question_limit: 0
    };
  },
  components: {
    RuleInfo, //抽题
    questionList //选题
  },
  mounted() {
    this.$nextTick(function() {
      that = this;
      this.question_limit = this.limit;
      if (this.id != 0) {
        //编辑
        this.getInfo();
      }
    });
  },
  methods: {
    setScore() {
      that.singleTotalScore = 0;
      that.multiTotalScore = 0;
      that.judgeTotalScore = 0;

      this.question.forEach(function(item, index) {
        if (item.subjectType == 0) {
          that.singleTotalScore += 1;
          item.score = that.singleScore;
        } else if (item.subjectType == 1) {
          that.multiTotalScore += 1;
          item.score = that.multiScore;
        } else if (item.subjectType == 2) {
          that.judgeTotalScore += 1;
          item.score = that.judgeScore;
        }
      });
    },
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    //抽题规则
    ruleSet() {
      this.RuleInfo.visible = true;
    },
    RuleInfoback() {
      this.RuleInfo.visible = false;
      if (arguments.length > 0) {
        var data = arguments[0];
        if (data.length > this.question_limit) {
          that.$message.error("最多不能超过" + this.question_limit + "个！");
          return;
        } else {
          if (that.question.length > 0) {
            that.question.forEach(function(i, idx) {
              data.forEach(function(item, index) {
                if (i.subjectId == item.id) {
                  data.splice(index, 1);
                }
              });
            });

            data.forEach(function(item, index) {
              that.question.push({
                subjectId: item.id,
                subjectType: item.subjectType,
                subjectName: item.questContent
              });
            });
          } else {
            data.forEach(function(item, index) {
              that.question.push({
                subjectId: item.id,
                subjectType: item.subjectType,
                subjectName: item.questContent
              });
            });
          }
          that.question.sort(function(a, b) {
            return a.subjectType - b.subjectType;
          });
          that.refreshQuestion();
          that.setScore();
        }
      }
    },
    //选题
    questionChoose() {
      this.questionList.visible = true;
      this.questionList.selList = this.question;
    },
    getquestion() {
      this.questionList.visible = false;
      if (arguments.length > 0) {
        var data = arguments[0];
        if (data.length > this.question_limit) {
          that.$message.error("最多不能超过" + this.question_limit + "个！");
          return;
        } else {
          that.question = data;
          that.question.sort(function(a, b) {
            return a.subjectType - b.subjectType;
          });
          that.refreshQuestion();
          that.setScore();
        }
      }
    },

    refreshQuestion() {
      that.singleTotalCount = 0;
      that.multiTotalCount = 0;
      that.judgeTotalCount = 0;
      this.question.forEach(function(item, index) {
        if (item.subjectType == 0) {
          that.singleTotalCount += 1;
        } else if (item.subjectType == 1) {
          that.multiTotalCount += 1;
        } else if (item.subjectType == 2) {
          that.judgeTotalCount += 1;
        }
      });
    },

    /**获取详情 */
    getInfo() {
      this.isloading = true;
      this.$api.testPaper
        .getById(this.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;
            this.question = res.data.subjectItems;
            this.question.sort(function(a, b) {
              return a.subjectType - b.subjectType;
            });
            this.question.forEach(function(item, index) {
              if (item.subjectType == 0) {
                that.singleTotalCount += 1;
                that.singleScore = item.score;
              } else if (item.subjectType == 1) {
                that.multiTotalCount += 1;
                that.multiScore = item.score;
              } else if (item.subjectType == 2) {
                that.judgeTotalCount += 1;
                that.judgeScore = item.score;
              }
              that.list.datas.push({
                id: item.subjectId,
                questContent: item.subjectName,
                score: item.score
              });
            });
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    removeInfo(id) {
      var idx;
      console.log(id)
      this.question.forEach(function(item, index) {
        if (item.subjectId == id) {
          idx = index;
        }
      });
      this.question.splice(idx, 1);
    },
    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          if (this.list.datas.length > this.question_limit) {
            that.$message.error("您的题目数量超出该考试题目限制！");
            return false;
          }
          var flag = true;
          for (var item in this.question) {
            if (!this.question[item].score) {
              that.$message.error("请输入题目分值！");
              return false;
            }
          }

          var ids = [];
          that.list.datas.forEach(function(item, index) {
            ids.push(item.id);
          });
          var subjectIds = [];
          this.question.forEach(function(item, index) {
            subjectIds.push({
              subjectId: item.subjectId,
              score: item.score,
              sortNum : index+1
            });
          });

          if (this.id != 0) {
            //修改
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.testPaper
              .update(
                this.id,
                values.testpaperName,
                this.examinationId,
                JSON.stringify(subjectIds)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //添加
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.testPaper
              .save(
                values.testpaperName,
                this.examinationId,
                JSON.stringify(subjectIds)
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    //子组件传值
    save() {
      this.info.visible = false;
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.ant-cascader-menu {
  height: 320px;
}
.questionList {
  margin-bottom: 30px;
}
</style>